import classNames from 'classnames';
import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

/**
 * This is the outerWrapper of the application
 */
function OuterWrapper({ children }: Props): JSX.Element {
  return (
    <div id='outerWrapper' className={classNames('flex grow flex-col min-h-[100%] bg-gray-200 dark:bg-dark overflow-y-scroll')}>
      {children}
    </div>
  );
}

export default OuterWrapper;
